var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isWeixin)?_c('div',{staticClass:"container2"},[_c('van-image',{staticClass:"wxtx",attrs:{"width":"100%","src":_vm.getImgUrl('publicMobile/common/transfer-wx1.jpg')}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }